export default "__VITE_ASSET__BaXxNRH2__"